import { render, staticRenderFns } from "./uploadFileDelRecord.vue?vue&type=template&id=1efe81b4&scoped=true&"
import script from "./uploadFileDelRecord.vue?vue&type=script&lang=js&"
export * from "./uploadFileDelRecord.vue?vue&type=script&lang=js&"
import style0 from "./uploadFileDelRecord.vue?vue&type=style&index=0&id=1efe81b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efe81b4",
  null
  
)

export default component.exports